import { Routes } from '@angular/router';
import { authGuard, passwordResetGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'authentication/login', pathMatch: 'full' },
  {
    path: 'authentication',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/authentication/login/login.page').then((m) => m.LoginPage),
      },
      {
        path: 'registro',
        loadComponent: () =>
          import('./pages/authentication/registro/registro.page').then(
            (m) => m.RegistroPage,
          ),
      },
      {
        path: 'registro/confirmacion',
        loadComponent: () =>
          import('./pages/authentication/registro-confirmacion/registro-confirmacion.page').then(
            (m) => m.RegistroConfirmacionPage,
          ),
      },
      {
        path: 'olvido-password',
        loadComponent: () =>
          import('./pages/authentication/olvido-password/olvido-password.page').then(
            (m) => m.OlvidoPasswordPage,
          ),
      },
      {
        path: 'olvido-password/confirmacion',
        loadComponent: () =>
          import('./pages/authentication/olvido-password-confirmacion/olvido-password-confirmacion.page').then(
            (m) => m.OlvidoPasswordConfirmacionPage,
          ),
      },
      {
        path: 'cambio-password',
        canActivate: [passwordResetGuard],
        loadComponent: () =>
          import('./pages/authentication/cambio-password/cambio-password.page').then(
            (m) => m.CambioPasswordPage,
          ),
      },
      {
        path: 'citas',
        loadComponent: () =>
          import('./pages/authentication/citas/citas.page').then((m) => m.CitasEmailPage),
      },
    ],
  },
  {
    path: 'citas/visitante/:token',
    loadComponent: () =>
      import('./pages/public/citas-visitante/citas-visitante.page').then(
        (m) => m.CitasVisitantePage,
      ),
  },
  {
    path: 'aviso-de-privacidad',
    loadComponent: () =>
      import('./pages/public/aviso-privacidad/aviso-privacidad.page').then(
        (m) => m.AvisoPrivacidadPage,
      ),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-inicio/dashboard-inicio.page').then(
            (m) => m.DashboardInicioPage,
          ),
      },
      {
        path: 'documentos',
        loadComponent: () =>
          import('./pages/dashboard/documentos-flow/documentos-flow.page').then(
            (m) => m.DocumentosFlowPage,
          ),
      },
      {
        path: 'proximamente/:moduloId',
        loadComponent: () =>
          import('./pages/dashboard/dashboard-proximamente/dashboard-proximamente.page').then(
            (m) => m.DashboardProximamentePage,
          ),
      },
      {
        path: 'situacion-cuotas',
        loadComponent: () =>
          import('./pages/dashboard/situacion-cuotas/situacion-cuotas.page').then(
            (m) => m.SituacionCuotasPage,
          ),
      },
      {
        path: 'citas',
        loadComponent: () =>
          import('./pages/dashboard/citas/citas.page').then((m) => m.CitasPage),
      },
      {
        path: 'citas/detalle/:id',
        loadComponent: () =>
          import('./pages/dashboard/citas/cita-detalle.page').then((m) => m.CitaDetallePage),
      },
      {
        path: 'citas/detalle/:id/cancelar',
        loadComponent: () =>
          import('./pages/dashboard/citas/cita-cancelar.page').then((m) => m.CitaCancelarPage),
      },
      {
        path: 'citas/detalle/:id/reprogramar',
        loadComponent: () =>
          import('./pages/dashboard/citas/cita-reprogramar.page').then(
            (m) => m.CitaReprogramarPage,
          ),
      },
    ],
  },
  { path: 'inicio', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'authentication/login' },
];
